<!-- Masthead-->
<header class="masthead">
    <div class="container h-100">
        <div class="row h-100 align-items-center justify-content-center text-center">
            <div class="col-lg-10 align-self-end">
                <h1 class="text-white font-weight-bold">Error 404</h1>
                <hr class="divider my-4" />
            </div>
            <div class="col-lg-8 align-self-baseline">
                <p class="text-white-75 font-weight-light mb-5">Lo sentimos. La url a la que intenta acceder no existe</p>
                <img src="./assets/img/YEMINUS.png" style="width: 200px;">
            </div>
        </div>
    </div>
</header>